import Form from "antd/lib/form";
import clsx from "clsx";
import { forwardRef, type ReactNode } from "react";
import { type UseControllerProps } from "react-hook-form";

import { Input } from "@sol/uikit/data-entry/Input/Input";

import { useFormSchema } from "../useFormSchema";
import { type BaseFieldProps, useFieldInfo } from "./useFieldInfo";

type Props = {
    hint?: ReactNode;
    placeholder?: string;
    className?: string;
} & BaseFieldProps &
    UseControllerProps;

export const TextAreaField = forwardRef<HTMLDivElement, Props>(function TextAreaField({ className, ...props }, ref) {
    const schema = useFormSchema();

    const fieldInfo = useFieldInfo(props, schema);
    const { label, hint, isRequired, errorMessage, max, placeholder, value = "", onBlur, onChange } = fieldInfo;

    return (
        <div ref={ref} className={clsx("flex flex-col gap-ant-xs", className)}>
            <Form.Item
                label={label}
                extra={hint}
                required={isRequired}
                validateStatus={errorMessage ? "error" : undefined}
                help={errorMessage}
                layout="vertical"
            >
                <Input.TextArea
                    autoSize={{ minRows: 4, maxRows: 8 }}
                    status={errorMessage ? "error" : undefined}
                    aria-invalid={`${!!errorMessage}`}
                    maxLength={max}
                    placeholder={placeholder}
                    value={value}
                    onBlur={onBlur}
                    onChange={onChange}
                />
            </Form.Item>
        </div>
    );
});
